import { all, takeLatest, call, put } from 'redux-saga/effects';

import { fetchSiteInfo as apiFetchSiteInfo } from '@coconut/services/apis/app';

import {
  FETCH_SITE_INFO,
  fetchSiteInfoSuccess,
  fetchSiteInfoFailure,
} from '@coconut/services/redux/siteInfo';

export function* fetchSiteInfoFlow() {
  try {
    const {
      faq,
      offering,
      multiple_offering_mode: multipleOfferingMode,
      regular_class_campaign_links: regularClassCampaignLinks,
      course_campaign_links: courseCampaignLinks,
      activity_links: activityLinks,
    } = yield call(apiFetchSiteInfo);
    const { web_footer: zendeskFAQLink } = faq;

    yield put(
      fetchSiteInfoSuccess({
        zendeskFAQLink,
        offerings: offering,
        multipleOfferingMode,
        campaignLinks: {
          regularClass: regularClassCampaignLinks,
          course: courseCampaignLinks,
          activity: activityLinks,
        },
      })
    );
  } catch (err) {
    yield put(fetchSiteInfoFailure());
  }
}

export default function* () {
  yield all([takeLatest(FETCH_SITE_INFO, fetchSiteInfoFlow)]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/siteInfo.js